import { createStore } from '@oneappexchange/lwc-wired';
import { IS_DEVELOPMENT, PRE_AUTH_REDIRECT_URL_LS_KEY, PUBLIC_URL, TOKENLESS_REDIRECT_URL } from '~/config';
import { createSession, getSession } from '../services/authService';
import { invalidJwtError, missingFeatureFlagsError } from '../utilities/errorUtilities';
import { featureFlagsStore } from './featureFlagStore';
import { routerStore } from './routerStore';
const initialState = {
  userData: null
};
export const userStore = createStore(initialState, (set, get) => ({
  reset() {
    set(function reset() {
      return initialState;
    });
  },
  async authenticate() {
    if (get().userData != null) {
      set(function resetUserData(draft) {
        draft.userData = null;
      });
    }
    const {
      params,
      url,
      queryString
    } = routerStore.getState();
    const token = params && params.token;

    // If we don't have a token, we must redirect the user to obtain one, or obtain one from the generate token service
    if (!token) {
      // Check if the user has an existing session
      const userData = await getSession();
      if (userData) {
        try {
          set(function authenticate(draft) {
            draft.userData = userData;
          });
          await featureFlagsStore.getFeatureFlags({
            context: selectContext(get())
          });
        } catch (error) {
          console.error(error);
          missingFeatureFlagsError();
          return null;
        }
        return userData;
      }
      if (TOKENLESS_REDIRECT_URL) {
        window.localStorage.setItem(PRE_AUTH_REDIRECT_URL_LS_KEY, `${url}${queryString ? `?${queryString}` : ''}`);
        window.location.assign(TOKENLESS_REDIRECT_URL);
        return null;
      }
    }

    // We should never get here without a token
    if (!token) {
      throw new Error('Failed to obtain token');
    }

    // Remove the token from the url
    const location = window.location.origin + PUBLIC_URL;
    window.history.replaceState(null, '', location + (url !== null && url !== void 0 ? url : ''));

    // Exchange the token for a jwt and validate it
    const userData = await createSession(token);
    if (!userData) {
      invalidJwtError();
      return null;
    }
    try {
      set(function authenticate(draft) {
        draft.userData = userData;
      });
      await featureFlagsStore.getFeatureFlags({
        context: selectContext(get())
      });
    } catch (error) {
      console.error(error);
      missingFeatureFlagsError();
      return null;
    }
    return userData;
  }
}), 'USER', IS_DEVELOPMENT);
function selectContext(state) {
  var _state$userData;
  return {
    properties: {
      accountId: (_state$userData = state.userData) === null || _state$userData === void 0 ? void 0 : _state$userData.org62AccountId
    }
  };
}
export function selectUserData(state) {
  return state.userData;
}